export const columnMap = {
  '1666653706550321162': '幻灯',
  '1666653706550321152': '法治报道',
  '1666653706550321158': '特别报道',
  '1666653706550321159': '快讯评论',
  '1666653706550321166': '环境监测',
  '1666653706550321167': '绿色低碳',
  '1666653706550321168': '在线留言',
  '1666653706550321169': '合作伙伴',
  '2005964315982508034': '友情链接',
  '2005975241485922305': '法治动态',
  '2005975373275148290': '品牌律所',
  '2005975485325979650': '知名律师',
  '2005975582365396993': '法律援助',
  '2005976467388706818': '环境健康',
  '2005976647236268034': '调研追问',
  '2005977081883602945': '践行社责',
  '2005977214046121986': '人企风采',
  '2005977345252339713': '环保基金',
  '2006741849233817602': '时政要闻',
  '2007112819224289282': '智库专家',
  '2070727008110985217': '舆情聚焦',
  '2070728210722799617': '企业培训',
  '2070728474133479425': '共建单位',
  '2070728856234573826': '青山绿水',
  '2070729217242513409': '智慧应急',
  '2070732072942780417': '人员查询',

  '2070859742678564865': '精彩视频',
  '2070859812132044801': '精彩图集',
  '2070860273119608834': '上级指导单位',
  '2070729457962008577': '对外公告',
  '1666653707573731328': '中心简介',
  '1666653707686977536': '联系我们',
  '2074076962699239426': '协办单位',
  '1666653706550321153': '新闻中心',
  '1666653706550321154': '关于我们',
  // '1666653706550321155': '联系我们',
  '1666653706550321160': '中心简介',
  '2007123581971931138': '中心联络处',
  '2070729941871443970': '组织框架',
  '2070729958904512513': '组织机构',
  '2070729971827163137': '组织人员',
  '2070729976940019713': '任命公示',
  '2070729981608280066': '授权公示',
  '2070729986721136641': '党建工作',
  '2070731115123130370': '分支机构',
  '2070731123021004802': '车辆认证',
  '2070731127626350594': '视频专栏',
  '2070731742863638529': '申请加入',
  '2074076826174644226': '协办单位',
}

// 通过栏目名称获取栏目ID
export function getColumnIdByName(name) {
  const entry = Object.entries(columnMap).find(([, label]) => label === name)
  return entry ? entry[0] : ''
}

// 通过栏目ID获取栏目名称
export function getColumnNameById(id) {
  return columnMap[id] || ''
}
